import { ENV } from "../utils";

export class EnvironmentalObjetivesform{
  baseApi = ENV.BASE_API;

  async geteEnvironmentalObjetivesForm(accessToken, idEnvironmentalObjetivesForm) {
    try {
      const url = `${this.baseApi}/environmentalObjetives/${idEnvironmentalObjetivesForm}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async createEnvironmentalObjetivesForm(accessToken, data) {
    try {
      // const formData = new FormData();
      // Object.keys(data).forEach((key) => {
      //   formData.append(key, data[key]);
      // });
      // const url = `${this.baseApi}/${ENV.API_ROUTES.USER}`;
      //console.log(data);
      const url = `${this.baseApi}/add-environmentalobjetives`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getEnvironmentalObjetivesForms(accessToken, paramsEnvironmentalObjetives, active = undefined) {
    try {
      const pageFilter = `page=${paramsEnvironmentalObjetives?.page || 1}`;
      const limitFilter = `limit=${paramsEnvironmentalObjetives?.limit || 10}`;
      const siteFilter = `site=${paramsEnvironmentalObjetives?.site || undefined}`;
      // const url = `${this.baseApi}/${ENV.API_ROUTES.USERS}?active=${active}`;
      let url = `${this.baseApi}/environmentalObjetivess?${pageFilter}&${limitFilter}`;
      if (active !== undefined) {
        url = `${this.baseApi}/environmentalObjetivess?active=${active}&${pageFilter}&${limitFilter}`;
      }
      if (paramsEnvironmentalObjetives?.site) {
        url = `${url}&${siteFilter}`;
      }
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateEnvironmentalObjetivesForm(
    accessToken,
    idEnvironmentalObjetivesForm,
    environmentalObjetivesformData
  ) {
    try {
      const data =environmentalObjetivesformData;

      // const formData = new FormData();
      // Object.keys(data).forEach((key) => {
      //   formData.append(key, data[key]);
      // });

      // const url = `${ENV.BASE_API}/${ENV.API_ROUTES.USER}/${idUser}`;
      const url = `${ENV.BASE_API}/environmentalObjetives/${idEnvironmentalObjetivesForm}`;
      const params = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteEnvironmentalObjetivesForm(accessToken, idEnvironmentalObjetivesForm) {
    try {
      // const url = `${this.baseApi}/${ENV.API_ROUTES.USER}/${idUser}`;
      const url = `${this.baseApi}/delete-environmentalObjetives/${idEnvironmentalObjetivesForm}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async existsEnvironmentalObjetivesFormByPeriodAndYear(accessToken, siteId, period, year) {
    try {
      const url = `${this.baseApi}/environmentalObjetives-exists-site/${siteId}/${period}/${year}`;

      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getPeriodsEnvironmentalObjetivesFormsBySiteAndYear(accessToken, siteId, year) {
    try {
      const url = `${this.baseApi}/environmentalObjetivess-periods-site-year/${siteId}/${year}`;

      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getEnvironmentalObjetivesFormsBySiteAndYear(accessToken, siteId, year) {
    try {
      const url = `${this.baseApi}/environmentalobjetives-site-year/${siteId}/${year}`;

      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getEnvironmentalObjetivesFormsBySite(accessToken, siteId) {
    try {
      const url = `${this.baseApi}/environmentalobjetives-site/${siteId}`;

      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

   async getEnvironmentalObjectivesByYearAndAspect(accessToken, siteId, year,aspect) {
    try {
      const url = `${this.baseApi}/environmentalobjetives-site-year-aspect/${siteId}/${year}/${aspect}`;

      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async uploadFileApi(accessToken, data) {
    const url = `${this.baseApi}/upload-file-environmentalObjetives/`;

    const params = {
      method: "POST",
      body: data,
      headers: {
        //'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${accessToken}`,
      },
    };
    return fetch(url, params)
      .then((response) => {
        
        return response.json();
      })
      .then((result) => {
        return result;
      })
      .catch((err) => {
        return err.message;
      });
  }

  async getFileApi(fileName) {
    const url = `${this.baseApi}/get-file-environmentalObjetives/${fileName}`;
    return fetch(url)
      .then((response) => {
        //console.log(response)
        return response.url;
      })
      .catch((err) => {
        return err.message;
      });
  }

  async deleteFileApi(accessToken, fileName) {
    const url = `${this.baseApi}/delete-file-environmentalObjetives`;

    const params = {
      method: "DELETE",
      body: JSON.stringify({ fileName }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    };
    return fetch(url, params)
      .then((response) => {
        return response.url;
      })
      .catch((err) => {
        return err.message;
      });
  }

  async getTotalBaselineByYearAndSite(accessToken, siteId, year, baseline) {
    try {
      const url = `${this.baseApi}/environmentalObjetives-baseline-total-site-year/${siteId}/${year}/${baseline}`;

      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

   
}
